import type { LogFn } from '../../log.js';
import { execGitFile } from '../git-exec.js';

export type GitRunResult = { ok: boolean; error?: string };

export async function gitStashCreate(repoRoot: string, log: LogFn): Promise<string> {
  try {
    const { stdout } = await execGitFile(['stash', 'create'], { cwd: repoRoot });
    return stdout.trim();
  } catch (e) {
    log(
      `[snapshot] Git stash create failed in ${repoRoot}: ${e instanceof Error ? e.message : String(e)}`,
    );
    return '';
  }
}

export async function gitUntrackedPaths(repoRoot: string, log: LogFn): Promise<string[]> {
  try {
    const { stdout } = await execGitFile(['ls-files', '--others', '--exclude-standard'], { cwd: repoRoot });
    return stdout
      .split('\n')
      .map((l) => l.trim())
      .filter(Boolean);
  } catch (e) {
    log(
      `[snapshot] Git ls-files --others failed in ${repoRoot}: ${e instanceof Error ? e.message : String(e)}`,
    );
    return [];
  }
}

export async function gitRun(
  repoRoot: string,
  args: string[],
  log: LogFn,
  label: string
): Promise<GitRunResult> {
  try {
    await execGitFile(args, { cwd: repoRoot });
    return { ok: true };
  } catch (e) {
    const msg = e instanceof Error ? e.message : String(e);
    log(`[snapshot] Git ${label} failed in ${repoRoot}: ${msg}`);
    return { ok: false, error: msg };
  }
}
